import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { Loader } from "lucide-react";

const getAdminHomeRoute = (role) => {
  switch (role) {
    case "super_admin":
    case "branch_manager":
      return "/dashboard";
    case "staff":
      return "/dashboard-staff";
    default:
      return "/admin-login";
  }
};

const AdminProtectedRoute = ({ permission, children }) => {
  const { isAuthenticated, admin, adminRole, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loader className="h-8 w-8 animate-spin text-[#f0653a]" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  // super admin = god mode
  if (adminRole === "super_admin") {
    return children;
  }

  if (permission) {
    const permissions = admin?.permissions || [];
    if (!permissions.includes(permission)) {
      return <Navigate to={getAdminHomeRoute(adminRole)} replace />;
    }
  }

  return children;
};

export default AdminProtectedRoute;
